import { Controller } from "@hotwired/stimulus";

// Fallback for when a thumbnail variant fails to process and the Turbo
// broadcast never arrives. Renders an <img> pointing at the representation
// URL, falling back to server-side variant generation on fetch.
export default class extends Controller {
  static values = { url: String };
  static targets = ["fallback"];

  connect() {
    this.timer = setTimeout(() => {
      if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("hidden");
    }, 5_000);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  load() {
    const img = document.createElement("img");
    img.src = this.urlValue;
    img.className = "w-full h-full object-cover";
    this.element.replaceChildren(img);
  }
}
